import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService, session_keys } from "@app/core";
import { UIUtil } from "@app/core/utils/ui.util";
import JSEncrypt from "jsencrypt";
import { NzMessageService } from "ng-zorro-antd";

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.scss"],
})
export class ResetPasswordComponent implements OnInit {
  oldPassword;
  newPassword;
  confirmPassword;

  newPwdVisible: boolean = false;
  oldPwdVisible: boolean = false;
  confirmPwdVisible: boolean = false;

  hideOldPwd: boolean = true;
  hideNewPwd: boolean = true;
  hideConfirmPwd: boolean = true;

  encrypt = new JSEncrypt();
  decrypt = new JSEncrypt();
  encryptedData: string;

  publicKey = `
    -----BEGIN PUBLIC KEY-----
  MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAqBQi7hZ1rU0f14jnzeAH
  fyY5ElLQKJ9uCikWHmrBNF0jwplmO9Upb0nrkcBZiPHCTpBlPVytbH44v6cGw4Pr
  PtyrTsI/PfHlYtmB/rTZ9zV19y+ZCrNM1faLvDqDiFP0B9Jffd9uTwlihmusDWgI
  +DiV/uPbKey7YXI0+ZdWV8IN8bTPyO4aXVRg8gSiZZTqlN59Z++tP8kjR9bZCqpk
  dN7UA3ULnE9tMqUnd7wA0RX/a9hVxPkMnQceGZk1hH82BtP8ONKnwjR42PYbvKEY
  wQzaGOHHISwvoDB5QsqivGb48ivF04aZlBGVgPlJIsHf+ihkLwQcux3hddCUKSWT
  7QIDAQAB
  -----END PUBLIC KEY-----
    `;

  userDetails = UIUtil.getPrivateData(session_keys.private_key);
  // loginUserEmail = JSON.parse(localStorage.getItem("PRIVATE_KEY")).email;
  constructor(
    // public loginService: LoginService,
    public router: Router,
    private message: NzMessageService,
    private authenticationService: AuthenticationService,
    private _router: Router,
  ) {}

  ngOnInit() {}

  pwdValidationError: any = null;
  checkPwdValidation(event) {
    this.pwdValidationError = null;
    let pwd = event.target.value;
    const strongPwdRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).+$/;

    if (pwd.length < 10) {
      this.pwdValidationError = "Password must be at least 10 characters long";
      return false;
    } else if (!strongPwdRegex.test(pwd)) {
      this.pwdValidationError =
        "Password must include at least one uppercase letter, one lowercase letter, one number, and one special character";
      return false;
    } else if (this.hasRepeatedCharacters(pwd.toLowerCase())) {
      this.pwdValidationError =
        "Password must not contain a character that repeats more than twice consecutively";
      return false;
    } else if (pwd.toLowerCase().startsWith("federal")) {
      this.pwdValidationError = "Password must not start with 'federal'";
      return false;
    } else if (this.hasSequentialChars(pwd)) {
      this.pwdValidationError =
        "Password must not contain sequential characters (e.g., abc, 123)";
      return false;
    } else if (pwd.toLowerCase() == this.userDetails.email.toLowerCase()) {
      this.pwdValidationError =
        "Password must not be your registered email address'";
      return false;
    } else {
      this.pwdValidationError = null;
    }
    this.checkConfirmPwdValidation();
  }

  confirmValidationError: any = null;
  checkConfirmPwdValidation() {
    this.confirmValidationError = null;
    if (this.newPassword !== this.confirmPassword) {
      this.confirmValidationError =
        "Passwords do not match. Please ensure both entries are identical.";
      return false;
    } else {
      this.confirmValidationError = null;
    }
  }

  hasRepeatedCharacters(password: string): boolean {
    return /(.)\1{2,}/.test(password);
  }

  hasSequentialChars(str: string, length = 3): boolean {
    const s = str.toLowerCase();
    for (let i = 0; i <= s.length - length; i++) {
      let asc = true;
      let desc = true;
      for (let j = 0; j < length - 1; j++) {
        const curr = s.charCodeAt(i + j);
        const next = s.charCodeAt(i + j + 1);
        if (next !== curr + 1) asc = false;
        if (next !== curr - 1) desc = false;
      }
      if (asc || desc) return true;
    }
    return false;
  }

  checkPasswordMatch = () => {
    if (this.newPassword !== "" && this.confirmPassword !== "") {
      if (this.newPassword !== this.confirmPassword) {
        return true;
      }
    }
    return false;
  };

  resetPwd() {
    if (this.pwdValidationError && this.confirmValidationError) {
      this.message.error("Please fill all the required fields to continue");
      return false;
    }

    if (this.oldPassword == this.newPassword) {
      this.message.error("Old and new password should be different!");
      return false;
    }

    let user_details = this.userDetails;
    this.encrypt.setPublicKey(this.publicKey);
    const newpassword: any = this.encrypt.encrypt(this.newPassword);
    const prePassword: any = this.encrypt.encrypt(this.oldPassword);
    const password_reset_token = user_details.password_reset_token;

    this.authenticationService
      .resetPwd(
        UIUtil.getPrivateData(session_keys.private_key).email,
        prePassword,
        newpassword,
        password_reset_token,
      )
      .subscribe(
        (response) => {
          user_details.token = response.token;
          user_details.is_password_expired = false;
          user_details.password_reset_token = null;
          UIUtil.savePrivateData(session_keys.private_key, user_details);
          this._router.navigate(["./view"]);
        },
        (err) => {
          this.message.error(err.Message);
        },
      );
  }
}
